export const router = {
  Auth: {
    Login: "/login",
    Register: "/register",
    ForgotPassword: "/forgotpassword",
    ResetPassword: "/resetpassword",
  },
  Home: {
    Origin: "/",
  },
  Profile: {
    AddSubAccount: "/add-sub-account",
  },
  Manager: {
    AccountManagement: "account-management",
  },
};

export const queryKeys = {
  profile: "profile",
  listHost: "list-host",
  configTable: "config-table",
  staffDrag: "staff-drag",
  defaultConfigTable: "default-config-table",
  orderList: "order-list",
  okuriList: "okuri-list",
  timeLineInfo: "timeline-info",
  listTableSession: "list-table-session",
  listStaffDuplicate: "list-staff-duplicate",
  checkTableNotDone: "check-table-not-done",
  listTimeWorkStaff: "list-time-work-staff",
  detailTable: "detail-table",
  updateTable: "update-table",
  staffCount: "staff-count",
  sortListTable: "sortListTable",
  historyTable: "historyTable",
  inRandom: "inRandom",
  listConfig: "listConfig",
  showListStaff: "showListStaff",
};

export const colors = [
  "#31d3d3",
  "#ecd56f",
  "#fe1657",
  "#bc16fe",
  "#0b6921",
  "#9aa22c",
];

export const ConversationEvent = {
  LOGIN: "LOGIN",
  LOGOUT: "LOGOUT",
  CREATE_TABLE: "CREATE_TABLE",
  UPDATE_TABLE: "UPDATE_TABLE",
  UPDATE_DETAIL_TABLE: "UPDATE_DETAIL_TABLE",
  UPDATE_HOST: "UPDATE_HOST",
  SYNC_DATA: "SYNC_DATA",
  RELOAD_TABLE: "RELOAD_TABLE",
};

export const BREAKPOINTS = {
  MOBILE: 480,
  TABLET: 768,
  PC: 1367,
};
